module.exports = __webpack_public_path__ + "static/media/开户客服@2x.3107aa34.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/开户客服@2x.png
// module id = 1590
// module chunks = 0